import { render, staticRenderFns } from "./DayWorkDetailsTabLeave.vue?vue&type=template&id=7540cb28&"
import script from "./DayWorkDetailsTabLeave.vue?vue&type=script&lang=js&"
export * from "./DayWorkDetailsTabLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports